import React from 'react';

export default function ProcurementOrdersToggle({ product, expanded, onToggleExpand }) {
  return (
    <button
      type='button'
      className='btn btn-link dropdown-toggle procurement-orders-toggle'
      aria-expanded={expanded}
      aria-controls={`procurement-orders-${product.productId}`}
      onClick={() => onToggleExpand(product.productId)}
    >
      Замовлення з товаром ({new Set(product.orders.map(line => line.orderId)).size})
    </button>
  );
}
